module.exports = __webpack_public_path__ + "static/img/icon_game_8.2ed0267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_8.png
// module id = SPGN
// module chunks = 0